import React from 'react';

export function SpectrumSlider({ value, onChange, min = 1, max = 10, labels = [], className = '' }) {
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className={`space-y-1 ${className}`}>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={e => onChange(parseInt(e.target.value))}
        className="w-full accent-amber-500"
      />
      {labels.length > 0 && (
        <div className="flex justify-between text-xs text-stone-500">
          {labels.map((label, idx) => (
            <span key={idx}>{label}</span>
          ))}
        </div>
      )}
      <div className="text-center text-sm font-medium text-amber-600">{value}/{max}</div>
    </div>
  );
}
